<template>
	<search-list :pageSizes="[25,30,40]" apiPath="/advertiserRule/list" :where="where" :searchKeys="searchKeys" ref="sl">
		<mm-lc title="Rule Status">
			<mm-adv-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple></mm-users>
		</mm-lc>
		<template slot="statusAction">
			<el-dropdown size="mini" trigger="click">
				<el-button size="small" type="primary">
					<i class="el-icon-edit"></i>Change Status
				</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="status-active" @click.native="changeStatus('active')">Switch to Active</el-dropdown-item>
					<el-dropdown-item class="status-paused" @click.native="changeStatus('paused')">Switch to Paused</el-dropdown-item>
					<el-dropdown-item class="status-pending" @click.native="changeStatus('pending')">Switch to Pending</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</template>
		<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectRule">
			<el-table-column type="selection"></el-table-column>
			<el-table-column label="Adv. ID" prop="adv_id" />
			<el-table-column label="Adv. Name" prop="adv_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" :row_type="'adv'"/>
			</el-table-column>
			<el-table-column label="Adv. BudGet($)" prop="adv_budget" />
			<el-table-column label="Adv. Offer BudGet($)" prop="adv_offer_budget" />
			<el-table-column label="Rule Status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Operator" prop="operator" />
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown size="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="editRule(sp.row)">Edit Rule</el-dropdown-item>
							<el-dropdown-item @click.native="edit(sp.row)">Edit Advertiser</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			adv_name: { label: "Adv Name", fuzzy: true },
			adv_id: { label: "Adv Id" }
		};
		return {
			searchKeys,
			where: {
                status: "",
                operator: ""
			},
			adv_arr:[],
		};
	},
	methods: {
		edit(row){
			window.open('/advEdit?id='+row.adv_id);
		},
		editRule(row){
			window.open('/advRuleEdit?id='+row.adv_id);
		},
		selectRule(adv_arr){
			this.adv_arr = adv_arr;
		},
		async changeStatus(status){
			if(this.adv_arr.length == 0){
				this.$message({
					type:'error',
					message:'Nothing Change'
				});
				return;
			}
			let adv_ids = [];
			for (const adv of this.adv_arr) {
				adv_ids.push([adv.adv_id]);
			}
			const result = await this.$post('/advertiserRule/updateAll',{status:status,adv_ids:adv_ids});
			if(result){
				this.$refs.sl.refresh();
			}
		}
	}
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
